
import { Component, Vue } from "vue-property-decorator";
// import { appList, pageMenus, exportGoods } from "@/api"; // @ is an alias to /src
import { Bar, Pie, ELine } from "@/components";
import countTo from "vue-count-to";
import { format } from "timeago.js";

@Component({
  name: "Home",
  components: {
    Bar,
    Pie,
    ELine,
    countTo,
  },
})
export default class Home extends Vue {
  private nums = {
    sales: 0,
    people: 0,
    amount: 0,
  };
  private updateTime = "";

  private mounted() {
    setTimeout(() => {
      this.nums = {
        sales: 13000,
        people: 20000,
        amount: 108000,
      };
      this.updateTime = format("2022-03-27 20:33:00", "zh_CN");
    }, 1000);
    // pageMenus({ appId: 107, versionId: 82 }).then((res) => {
    //   console.log(res);
    // });
    // appList({ page: 1, pageSize: 100 }).then((res) => {
    //   console.log(res);
    // });
    // const formData = new FormData();
    // formData.append("goodsId", "361283163160578,361274405355522");
    // exportGoods(formData)
    //   .then(
    //     (res) => {
    //       console.log("res:", res);
    //     },
    //     (rej) => {
    //       console.log("rej:", rej);
    //     }
    //   )
    //   .catch((e) => {
    //     console.log("catch:", e);
    //   });
  }
}
